import React from 'react';
import style from './style.scss';
import {DateTime} from 'components/UI/DateTime';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';

class EasyNeedOffer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <div className="easy-need-offer">
        <div className='easy-need-offer-left-content'>
          <Link to={'/'} className='product-link'>
            <img className='product-image' src={this.props.image}/>
            <UploadImage transform="crop" className='product-image' width="68" height="68" type="USER" image={this.props.user.businesses.length > 0 ? this.props.user.businesses[0].logo : this.props.user.avatar}/>
          </Link>
        </div>
        <div className='easy-need-offer-right-content'>
          <p className='description'>{this.props.content}</p>
          <div className='content-justify'>
            <h2 className='name-company'><Link className='name-link' to={`business/${this.props.user.businesses[0].id}`}>{this.props.user.businesses.length > 0 ? this.props.user.businesses[0].name : this.props.user.fullname}</Link></h2>
            <p className='time'><i className='vtd-calendar'/><DateTime dateTime={this.props.updatedAt}/></p>
          </div>
        </div>
      </div>
    );
  }
}

export default EasyNeedOffer;



// WEBPACK FOOTER //
// ./components/partials/easy-need-offer/EasyNeedOffer.jsx